import { render } from "./mergefilepopup.vue?vue&type=template&id=f8648fa2&scoped=true"
import script from "./mergefilepopup.vue?vue&type=script&lang=js"
export * from "./mergefilepopup.vue?vue&type=script&lang=js"

import "./mergefilepopup.vue?vue&type=style&index=0&id=f8648fa2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8648fa2"]])

export default __exports__